
/* @ngInject */
function MarketingCalendarCampaignsListController ($rootScope, $scope, $translate, Utils) {
  activate()

  function activate () {}
}

export { MarketingCalendarCampaignsListController }
